<template>
  <div class="video-player">
    <div class="video-player__container" ref="player">
      <iframe class="video-tag" :src="url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
import Plyr from 'plyr';

export default {
  data() {
    return {
      player: false,
    };
  },
  mounted() {
    this.player = new Plyr(this.$refs.player, {
      iconUrl: '',
      hideControls: false,
      iconPrefix: 'icon-player',
      disableContextMenu: false,
    });

    this.player.toggleControls(false);

    this.player.on('play', this.onPlay);
    this.player.on('pause', this.onPause);
    this.player.on('ended', this.onEnd);
  },
  methods: {
    onPlay() {
      this.player.toggleControls(true);
      this.$emit('on-play');
    },
    onPause() {
      this.$emit('on-pause');
    },
    onEnd() {
      this.$emit('on-end');
    },
  },
  props: ['url'],
};
</script>

<style lang="scss">
.video-player {
  position: relative;
  width: 100%;
  padding-top: 56%;
}

.plyr {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    z-index: 1;
    pointer-events: none;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.1));
  }

  .plyr__control--overlaid {
    background: transparent;

    &:hover {
      background: transparent;
    }

    svg {
      width: rem-calc(74);
      height: rem-calc(74);
    }
  }

  .plyr__control {
    padding: 0;

    &:hover {
      background: transparent;
    }
  }
}

.video-tag {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
